import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import AudioFields from './formGroup23AudioFields';
import SubtitleFields from './formGroup24SubtitleFields';

export default {
  title: 'Streams configuration',
  attributeName: 'stream',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'input',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'URL, IP:PORT or decklink_id',
      label: 'Main Input',
      required: true,
      default:'',
      helpText: 'Set Input stream eg(for SRT or RTP:192.168.10.10:27000, for HTTP: https://url.com/file.mpd and for decklinkg: cr1).',
      errorText: '',
    },
    {
      attributeName: 'backupInput',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'URL, IP:PORT or decklink_id',
      label: 'Backup Input',
      required: true,
      default:'',
      helpText: 'Set Input stream eg(for SRT or RTP:192.168.10.10:27000, for HTTP: https://url.com/file.mpd and for decklinkg: cr1).',
      errorText: '',
    },
  {
      attributeName: 'decklinkInputExample',
      type: FormInputTypes.STATIC_TEXT,
      placeholder: 'Input Example',
      label:"Decklink Input example",
      default:'cr1',
      required: true,
      errorText: '',
      classCss:'form-show-text__small form-show-text--block',
      classCssLabel:'form-show-text__small_bold',
      visibleWhen:[{"field":"source","value":'decklink'}],
    },
    {
      attributeName: 'srtInputExample',
      type: FormInputTypes.STATIC_TEXT,
      placeholder: 'Input Example',
      label:"SRT Input example",
      default:'srt://50.16.209.177:8080?rcvbuf=36700160&mode=caller&latency=200&transtype=live&linger=10&ffs=128000&pkt_size=1316&streamid=dev0-live.ybvr.com/live/main',
      required: true,
      errorText: '',
      classCss:'form-show-text__small form-show-text--block',
      classCssLabel:'form-show-text__small_bold',
      visibleWhen:[{"field":"source","value":'srt'}],
    },
    {
      attributeName: 'rtpInputExample',
      type: FormInputTypes.STATIC_TEXT,
      placeholder: 'Input Example',
      label:"RTP Input example",
      default:'192.168.1.1:27000',
      required: true,
      errorText: '',
      disabled:true,
      classCss:'form-show-text__small form-show-text--block',
      classCssLabel:'form-show-text__small_bold',
      visibleWhen:[{"field":"source","value":'rtp'}],
    },

    {
      attributeName: 'httpInputExample',
      type: FormInputTypes.STATIC_TEXT,
      placeholder: 'Input Example',
      label:"HTTP Input example",
      default:'https://test.com/file.mpd or https://test.com/file.m3u8 ',
      required: true,
      errorText: '',
      disabled:true,
      classCss:'form-show-text__small form-show-text--block',
      classCssLabel:'form-show-text__small_bold',
      visibleWhen:[{"field":"source","value":'http'}],
    },

    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'videoPublishID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Video publish ID',
      label: 'Video publish ID',
      required: true,
      // valueWhen:[{"from":"parent","node":"ingestServers","field":"type","value":["v","concat","left"]},{"field":"id","value":["-","concat","right",">1"]}],
      default:'v180-1',
      helpText: 'Set the video publish id.',
      errorText: '',
    },
    {
      attributeName: 'audioPublishID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Audio publish ID',
      label: 'Audio publish ID',
      required: true,
      helpText: 'Set the audio publish id.',
      visibleWhen:[{"field":"deploymentType","value":'ott'}],

      errorText: '',
    },
    {
      attributeName: 'audioDelay',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      placeholder: 'Audio Delay',
      label: 'Audio delay',
      required: true,
      default:'0',
      helpText: 'Set the audio publish id.',
      errorText: '',
      visibleWhen:[{"field":"deploymentType","value":'ott'},{"field":"audioPublishID","value":"not-null"}],

    },
     {
      attributeName: 'videoVariant',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: '0:v or number:number',
      label: 'Video variant',
      required: true,
      default:'0:v',
      helpText: 'Choose the http video variant it has the value 0:v or the format number:number',
      errorText: '',
      visibleWhen:[{"field":"deploymentType","value":'ott'}],
    },
    {
      attributeName: 'audioVariants',
      type: FormInputTypes.JSON_COMPONENT,
      itemLabel: 'Audio variant',
      columns: 1,
      label: 'Audio variants',
      errorText: '',
      classCss: "jsonComponent__width100",
      required: true,
      visibleWhen: [{ "field": "deploymentType", "value": "ott" }],
      disableWhen:[{ "field": "audioPublishID", "value": "not-null" }],
      extraValues:['deploymentType','type','source','audioPublishID'],
      popupFormGroups: [AudioFields],
      minItems: 1,
    },
    {
      attributeName: 'subtitleVariants',
      type: FormInputTypes.JSON_COMPONENT,
      itemLabel: 'Subtitle variant',
      columns: 1,
      label: 'Subtitle variants',
      errorText: '',
      classCss:"jsonComponent__width100",
      visibleWhen:[{ "field": "deploymentType", "value": "ott" }],
      disableWhen:[{ "field": "audioPublishID", "value": "not-null" }],
      extraValues:['deploymentType','type','source','audioPublishID'],
      popupFormGroups:[ SubtitleFields]
    },
     
  ]
};
